import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom"
import { Provider, useSelector } from "react-redux"
import { store } from "./app/store"
import type { RootState } from "./app/store"
import Sidebar from "./components/Sidebar"
import LoginPage from "./pages/LoginPage"
import OverviewPage from "./pages/OverviewPage"
import UsersPage from "./pages/UsersPage"
import BusinessesPage from "./pages/BusinessesPage"
import ReviewsPage from "./pages/ReviewsPage"
import RolesPage from "./pages/RolesPage"
import CategoriesPage from "./pages/CategoriesPage"
import SearchInsightsPage from "./pages/SearchInsightsPage"
import OrdersPage from "./pages/OrdersPage"
import SupportTicketsPage from "./pages/SupportTicketsPage"
import FAQsPage from "./pages/FAQsPage"
import CouponsPage from "./pages/CouponsPage"
import SubscriptionPlansPage from "./pages/SubscriptionPlansPage"
import ProductsPage from "./pages/ProductsPage"
import PaymentsPage from "./pages/PaymentsPage"
import WalletPage from "./pages/WalletPage"
import ReturnsPage from "./pages/ReturnsPage"
import SettingsPage from "./pages/SettingsPage"
import ProfilePage from "./pages/ProfilePage"
import CommissionPage from "./pages/CommissionPage"
import EarlyAdoptersPage from "./pages/EarlyAdoptersPage"

function RequireAuth() {
  const token = useSelector((s: RootState) => s.auth.token)
  if (!token) return <Navigate to="/login" replace />
  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      <main className="flex-1 p-8 overflow-auto">
        <Outlet />
      </main>
    </div>
  )
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<RequireAuth />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/businesses" element={<BusinessesPage />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/roles" element={<RolesPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/search-insights" element={<SearchInsightsPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/tickets" element={<SupportTicketsPage />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/coupons" element={<CouponsPage />} />
          <Route path="/subscriptions" element={<SubscriptionPlansPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/wallets" element={<WalletPage />} />
          <Route path="/returns" element={<ReturnsPage />} />
          <Route path="/commission" element={<CommissionPage />} />
          <Route path="/early-adopters" element={<EarlyAdoptersPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default function App() {
  return (
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  )
}
